function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F4F4"
    },
    d: "M503.983,64.134H8.017C3.589,64.134,0,67.722,0,72.15V439.85c0,4.428,3.589,8.017,8.017,8.017H430.23 c2.126,0,4.164-0.844,5.669-2.347l73.754-73.754c1.503-1.504,2.347-3.542,2.347-5.669V72.15 C512,67.722,508.412,64.134,503.983,64.134z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9E9E9"
    },
    d: "M8.017,64.134C3.589,64.134,0,67.722,0,72.15V439.85c0,4.428,3.589,8.017,8.017,8.017H346.82 L68.634,64.134H8.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9E9E9"
    },
    d: "M435.574,379.457v65.927c0.156,0.065,0.168,0.069,0.325,0.135l73.754-73.754 c-0.065-0.156-0.069-0.168-0.135-0.325h-65.927C439.163,371.441,435.574,375.03,435.574,379.457z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF7A6E"
    },
    d: "M196.142,260.81h-68.409c-4.427,0-8.017,3.588-8.017,8.017v136.818c0,3.037,1.716,5.813,4.432,7.17 c2.716,1.36,5.967,1.065,8.395-0.757l29.395-22.046l29.395,22.046c1.414,1.06,3.107,1.603,4.811,1.603 c1.222,0,2.45-0.279,3.584-0.847c2.716-1.359,4.432-4.133,4.432-7.17V268.827C204.159,264.398,200.569,260.81,196.142,260.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8C78"
    },
    d: "M280.045,213.511l-13.82-23.936v-27.638c0-2.865-1.529-5.51-4.008-6.942l-23.936-13.82l-13.82-23.936 c-1.432-2.48-4.078-4.008-6.942-4.008H189.88l-23.935-13.819c-2.48-1.432-5.537-1.432-8.017,0l-23.936,13.82h-27.638 c-2.865,0-5.51,1.529-6.942,4.008l-13.82,23.936l-23.936,13.82c-2.48,1.432-4.008,4.078-4.008,6.942v27.638L43.83,213.511 c-1.432,2.48-1.432,5.537,0,8.017l13.82,23.936v27.638c0,2.865,1.529,5.51,4.008,6.942l23.936,13.82l13.82,23.936 c1.432,2.48,4.078,4.008,6.942,4.008h27.638l23.936,13.82c2.456,1.418,5.56,1.418,8.017,0l23.936-13.82h27.637 c2.865,0,5.51-1.529,6.942-4.008l13.82-23.936l23.936-13.82c2.48-1.432,4.008-4.078,4.008-6.942v-27.638l13.82-23.936 C281.477,219.048,281.477,215.991,280.045,213.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9E9E9"
    },
    d: "M161.937,132.543c-46.856,0-84.977,38.12-84.977,84.977s38.121,84.977,84.977,84.977 s84.977-38.12,84.977-84.977S208.793,132.543,161.937,132.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBFBFB"
    },
    d: "M161.937,149.111c-37.721,0-68.409,30.688-68.409,68.409s30.688,68.409,68.409,68.409 s68.409-30.688,68.409-68.409S199.659,149.111,161.937,149.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DDAE1"
    },
    d: "M214.366,211.051l-47.031-42.756c-2.975-2.708-7.827-2.783-10.785,0l-47.031,42.756 c-3.276,2.978-3.518,8.049-0.54,11.325c0.088,0.095,0.176,0.189,0.267,0.28c3.007,3.007,7.877,3.149,11.057,0.259l5.168-4.699 L124,259.453c-0.171,4.818,3.88,8.303,8.535,8.303h13.373c4.427,0,8.017-3.589,8.017-8.017v-33.872c0-4.389,3.383-8.217,7.771-8.347 c4.54-0.135,8.263,3.504,8.264,8.013v34.205c0,4.427,3.589,8.017,8.017,8.017h13.896c4.427,0,8.017-3.589,8.017-8.017v-40.182 l3.692,3.356c3.276,2.978,8.347,2.737,11.325-0.54C217.882,219.1,217.621,214.041,214.366,211.051z M148.438,197.337l13.502-12.275 l14.16,12.873L148.438,197.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8C78"
    },
    d: "M160.101,345.329l-40.385-10.097v70.164c0,2.447,0.993,4.843,2.877,6.404 c2.936,2.433,7.034,2.445,9.949,0.259l29.395-22.046l29.395,22.046c2.576,1.931,6.171,2.124,8.933,0.462 c2.486-1.496,3.894-4.334,3.894-7.2v-68.916l-40.374,8.972C162.57,345.646,161.309,345.63,160.101,345.329z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBCBC"
    },
    d: "M391.963,191.332h-84.656c-4.428,0-8.017-3.588-8.017-8.017s3.588-8.017,8.017-8.017h84.656 c4.428,0,8.017,3.588,8.017,8.017S396.392,191.332,391.963,191.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBCBC"
    },
    d: "M461.228,191.332h-38.48c-4.428,0-8.017-3.588-8.017-8.017s3.588-8.017,8.017-8.017h38.48 c4.428,0,8.017,3.588,8.017,8.017S465.656,191.332,461.228,191.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBCBC"
    },
    d: "M461.228,234.088H307.307c-4.428,0-8.017-3.588-8.017-8.017s3.588-8.017,8.017-8.017h153.921 c4.428,0,8.017,3.588,8.017,8.017S465.656,234.088,461.228,234.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBCBC"
    },
    d: "M361.179,276.843h-53.872c-4.428,0-8.017-3.588-8.017-8.017s3.588-8.017,8.017-8.017h53.872 c4.428,0,8.017,3.588,8.017,8.017S365.608,276.843,361.179,276.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBCBC"
    },
    d: "M461.228,276.843h-69.264c-4.428,0-8.017-3.588-8.017-8.017s3.588-8.017,8.017-8.017h69.264 c4.428,0,8.017,3.588,8.017,8.017S465.656,276.843,461.228,276.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBCBC"
    },
    d: "M422.747,336.701h-76.96c-4.428,0-8.017-3.588-8.017-8.017c0-4.428,3.588-8.017,8.017-8.017h76.96 c4.428,0,8.017,3.588,8.017,8.017C430.764,333.113,427.176,336.701,422.747,336.701z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseSvgrepoCom);
export default __webpack_public_path__ + "static/media/license-svgrepo-com.645fdd5d2c0fcf33eb691655aabc5590.svg";
export { ForwardRef as ReactComponent };